<template>
  <month-year-picker-component
    v-if="activePicker === 'date'"
    :displayedDate="displayedDate"
    @previous="selectPreviousMonth"
    @next="selectNextMonth"
    @toggle-month-selector="toggleMonthSelector"
    @toggle-year-selector="toggleYearSelector"
  />
  <div v-else class="flex items-center font-semibold">
    <button @click="$emit('toggle-date-selector')">
      <div class="scale-75 transform">
        <i v-html="$icons.arrow_left" />
      </div>
    </button>
    <div
      class="flex w-full items-center justify-center"
      v-if="activePicker === 'month'"
    >
      {{ capitalize(moment(displayedDate).format("MMMM")) }}
    </div>
    <div
      class="flex w-full items-center justify-center"
      v-else-if="activePicker === 'year'"
    >
      {{ moment(displayedDate).format("YYYY") }}
    </div>
  </div>
</template>

<script>
import monthYearPickerComponent from "./month-year-picker.component.vue";
export default {
  components: { monthYearPickerComponent },

  props: {
    displayedDate: {
      type: Object,
    },
    activePicker: {
      type: String,
      validator: (val) => {
        return ["month", "year", "date"].includes(val);
      },
    },
  },

  methods: {
    selectPreviousMonth() {
      this.$emit("previous");
    },
    selectNextMonth() {
      this.$emit("next");
    },
    toggleMonthSelector() {
      this.$emit("toggle-month-selector");
    },
    toggleYearSelector() {
      this.$emit("toggle-year-selector");
    },
  },
};
</script>

<style></style>
